// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__+UcIs","button":"Button_button__CyEQF","outline":"Button_outline__+Y-zf"};